<div class="container-fluid">
	<div class="row">
		<div class="col-12 p-0">
			<div class="map-container">
				<div class="map-frame">
					<!-- class="dark-mode" -->
					<div
						id="map"
						leaflet
						[leafletOptions]="options"
						[leafletFitBounds]="fitBounds"
						(leafletMapReady)="onMapReady($event)"
						[leafletMarkerCluster]="layers"
						[leafletMarkerClusterOptions]="markerClusterOptions"
					></div>
					<!--aquí van las opciones del menu lateral izq.-->
				</div>
			</div>
			<div
				class="side-pane"
				[ngClass]="this.displayDialog === true ? 'data-displayed' : ''"
			>
				<mat-card class="mat-elevation-z3 w-100 p-0 sector-card">
					<mat-card-header class="card-details-header">
						<mat-card-title>{{
							"map.card.title" | translate
						}}</mat-card-title>
						<div class="close-button" (click)="closeDialog()">
							<mat-icon
								class="close-icon"
								aria-hidden="false"
								aria-label="link"
								fontIcon="cancel"
							></mat-icon>
						</div>
					</mat-card-header>
					<mat-card-content>
						<app-map-details-dialog
							*ngIf="selectedItem"
							[site]="selectedItem"
						>
						</app-map-details-dialog>
					</mat-card-content>
				</mat-card>
			</div>
		</div>
	</div>
</div>
<div class="filter-container">
	<div class="filter-info">{{ "map.filter.info" | translate }}</div>
	<mat-chip-listbox multiple="true" aria-label="Fish selection">
		<mat-chip-option
			(click)="filterAllTypes()"
			[ngClass]="{ selected: this.filterSelection.length == 0 }"
			>{{ "map.filter.all" | translate }}</mat-chip-option
		>
		<mat-chip-option
			[ngClass]="{ selected: this.filterSelection.indexOf(option) > -1 }"
			(click)="filterType(option)"
			*ngFor="let option of this.filterOptions"
			>{{ "site.type." + option | translate }}
		</mat-chip-option>
	</mat-chip-listbox>
</div>
